/*
 * ── Tobros 19/10/2026 (Claude) · Αναζήτηση με μέρος κωδικού, χωρίς νέο app ──
 * Η αναζήτηση του Shopify βρίσκει κωδικό μόνο από την αρχή του ("3MO1112-B166NV" ναι, "O1112-B166NV" όχι).
 * Όταν μια αναζήτηση που μοιάζει με κωδικό δεν βρει τίποτα, ψάχνει τον κωδικό σε ελαφρύ ευρετήριο
 * (/collections/all?view=codes → templates/collection.codes.liquid) και ξαναψάχνει με τον πλήρη κωδικό.
 * Το ευρετήριο κατεβαίνει μόνο τότε και κρατιέται 12 ώρες στον browser.
 * Rollback: επαναφορά αυτού του αρχείου στην έκδοση πριν τις 19/10/2026 (ή σβήσιμο του μπλοκ μέχρι το "Τέλος Tobros").
 */
(function () {
  if (window.TobrosCodeSearch) return;

  var KEY = 'tobros-code-index-v1';
  var TTL = 12 * 60 * 60 * 1000;
  var GREEK = { 'Α': 'A', 'Β': 'B', 'Ε': 'E', 'Ζ': 'Z', 'Η': 'H', 'Ι': 'I', 'Κ': 'K', 'Μ': 'M', 'Ν': 'N', 'Ο': 'O', 'Ρ': 'P', 'Τ': 'T', 'Υ': 'Y', 'Χ': 'X' };
  var memo = null;

  function norm(s) {
    return String(s || '').toUpperCase().replace(/[ΑΒΕΖΗΙΚΜΝΟΡΤΥΧ]/g, function (c) { return GREEK[c]; }).replace(/[^A-Z0-9]/g, '');
  }

  function looksLikeCode(q) {
    q = String(q || '').trim();
    return q.length >= 4 && q.length <= 40 && !/\s/.test(q) && /\d/.test(q) && norm(q).length >= 4;
  }

  function root() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  }

  function fetchPage(n) {
    return fetch(root() + 'collections/all?view=codes&page=' + n, { credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) throw new Error(r.status);
      return r.text();
    });
  }

  function parse(text, list) {
    var lines = text.split('\n');
    for (var i = 1; i < lines.length; i++) {
      var line = lines[i].trim();
      if (!line) continue;
      var parts = line.split('|');
      var codes = (parts[0] || '').split(' ').filter(Boolean);
      var sku = (parts.slice(1).join('|') || '').trim();
      if (codes.length || sku) list.push([codes, sku]);
    }
    return parseInt(lines[0], 10) || 1;
  }

  function load() {
    if (memo) return memo;
    try {
      var cached = JSON.parse(localStorage.getItem(KEY) || 'null');
      if (cached && cached.t && Date.now() - cached.t < TTL && cached.d && cached.d.length) {
        memo = Promise.resolve(cached.d);
        return memo;
      }
    } catch (e) {}

    memo = fetchPage(1).then(function (first) {
      var list = [];
      var pages = Math.min(parse(first, list), 60);
      var rest = [];
      for (var p = 2; p <= pages; p++) rest.push(p);
      var results = [];
      var next = 0;
      function worker() {
        if (next >= rest.length) return Promise.resolve();
        var idx = next++;
        return fetchPage(rest[idx]).then(function (t) { results[idx] = t; }).catch(function () {}).then(worker);
      }
      return Promise.all([worker(), worker(), worker(), worker()]).then(function () {
        results.forEach(function (t) { if (t) parse(t, list); });
        try { localStorage.setItem(KEY, JSON.stringify({ t: Date.now(), d: list })); } catch (e) {}
        return list;
      });
    }).catch(function (e) {
      memo = null;
      throw e;
    });
    return memo;
  }

  function skuStem(sku) {
    var s = String(sku || '').replace(/\|/g, '-');
    var m = s.match(/^(.*)-([^-]{1,4})$/);
    return (m && m[1].length >= 4 ? m[1] : s);
  }


  function resolve(q) {
    if (!looksLikeCode(q)) return Promise.resolve(null);
    var nq = norm(q);
    // Όρος χωρίς διαχωριστικά (π.χ. "O1112"): ψάχνει μέσα σε κάθε κομμάτι του κωδικού χωριστά.
    // Όρος με διαχωριστικά (π.χ. "O1112-B166NV"): ψάχνει σε ολόκληρο τον κωδικό.
    var whole = /[^A-Za-z0-9\u0370-\u03FF]/.test(String(q).trim());
    function matches(code) {
      if (whole) return norm(code).indexOf(nq) > -1;
      var parts = String(code).split(/[^A-Za-z0-9\u0370-\u03FF]+/);
      for (var k = 0; k < parts.length; k++) if (norm(parts[k]).indexOf(nq) > -1) return true;
      return false;
    }
    return load().then(function (list) {
      var hits = [];
      for (var i = 0; i < list.length && hits.length < 60; i++) {
        var codes = list[i][0], sku = list[i][1], hit = null;
        for (var j = 0; j < codes.length; j++) {
          if (matches(codes[j])) { hit = codes[j]; break; }
        }
        if (!hit && sku && matches(sku)) hit = skuStem(sku);
        if (hit) hits.push(hit);
      }
      if (!hits.length) return null;
      var exact = hits.filter(function (h) { return norm(h) === nq; });
      if (exact.length === hits.length) return null;
      if (hits.length === 1) return hits[0];
      // Πολλά προϊόντα: κοινό αρχικό κομμάτι του κωδικού (η αναζήτηση του Shopify το βρίσκει ως πρόθεμα)
      var prefix = hits.reduce(function (a, b) {
        var k = 0;
        while (k < a.length && k < b.length && a.charAt(k).toUpperCase() === b.charAt(k).toUpperCase()) k++;
        return a.slice(0, k);
      });
      prefix = prefix.replace(/[^A-Za-z0-9]+$/, '');
      if (prefix.length >= 4 && norm(prefix).indexOf(nq) > -1) return prefix;
      return hits[0];
    }).catch(function () { return null; });
  }

  window.TobrosCodeSearch = { resolve: resolve, looksLikeCode: looksLikeCode };

  // Σελίδα αναζήτησης χωρίς αποτελέσματα: αν ο όρος είναι μέρος κωδικού, ξαναψάχνει με τον πλήρη κωδικό.
  function onSearchPage() {
    var el = document.querySelector('[data-code-search-term]');
    if (!el) return;
    var url = new URL(window.location.href);
    if (url.searchParams.get('cs') === '1') return;
    var term = el.getAttribute('data-code-search-term');
    if (!looksLikeCode(term)) return;
    resolve(term).then(function (alt) {
      if (!alt || norm(alt) === norm(term)) return;
      url.searchParams.set('q', alt);
      url.searchParams.set('cs', '1');
      url.searchParams.delete('page');
      url.searchParams.delete('options');
      url.searchParams.set('options[prefix]', 'last');
      window.location.replace(url.pathname + '?' + url.searchParams.toString());
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', onSearchPage);
  else onSearchPage();
})();
// ── Τέλος Tobros 19/10/2026 ──

// Tobros 19/10/2026: βλ. μπλοκ στην αρχή του αρχείου
function loadTobrosCodeSearch() {
  return Promise.resolve(window.TobrosCodeSearch || null);
}

if (!customElements.get('predictive-search')) {
  class PredictiveSearch extends HTMLElement {
    constructor() {
      super();

      this.input = this.querySelector('input[type="search"]');
      this.resultsContainer = this.querySelector(
        '.js-results-container'
      );
      this.btnSubmit = this.querySelector('.js-btn-submit');
      this.btnClearText = this.querySelector('.js-btn-clear-text');
      this.errorMessageContainer = this.querySelector(
        '.js-message-error'
      );
      this.errorMessageText =
        this.errorMessageContainer.querySelector('[data-text]');
      this.timeout = null;
      this.isOpen = false;
      this.drawer = this.closest('.js-drawer');

      var searchDrawerContent = document.querySelector('.drawer__content--search');
      var searchSuggestions = document.querySelector('.search-drawer__suggestions');

      this.input.addEventListener('input', e => {
        clearTimeout(this.timeout);

        this.timeout = setTimeout(() => {
          const searchTerm = this.input.value.trim();

          if (searchTerm.length <= 0) {
            this.close();
            if(DeviceDetector.isMobile() || DeviceDetector.isTablet()) {
              searchDrawerContent.style.height = 'auto';
            }
            if(searchSuggestions) {
              searchSuggestions.style.display = 'block';
            }
            return;
          }

          this.isOpen = true;
          this.getSearchResults(searchTerm);
          if(DeviceDetector.isMobile() || DeviceDetector.isTablet()) {
            searchDrawerContent.style.height = '100%';
          }
          if(searchSuggestions) {
            searchSuggestions.style.display = 'none';
          }
        }, 300);
      });

      this.input.addEventListener('keydown', e => {
        const isEscape = e.key === 'Escape';

        if (!isEscape) {
          return;
        }

        if (!this.input.value) {
          if (this.drawer) {
            this.drawer.parentElement.parentElement.toggleDrawer();
          }

          return;
        }

        this.close();
      });

      this.btnClearText.addEventListener('click', e => {
        this.close();
        searchDrawerContent.style.height = 'auto';
        if(searchSuggestions) {
          searchSuggestions.style.display = 'block';
        }
      });
    }

    async getSearchResults(searchTerm) {
      try {
        const response = await fetch(
          `${Shopify.routes.root}search/suggest?q=${searchTerm}&resources[type]=product,page,article,collection,query&resources[limit]=8&section_id=predictive-search`
        );

        if (!this.isOpen) {
          return;
        }

        if (!response.ok) {
          const error = new Error(response.status);

          throw error;
        }

        let text = await response.text();

        // Tobros 19/10/2026: αναζήτηση με μέρος κωδικού (βλ. μπλοκ στην αρχή του αρχείου)
        if (!/predictive-search__col-product[\s\S]*?predictive-search__grid/.test(text) && searchTerm.length >= 4 && /\d/.test(searchTerm) && !/\s/.test(searchTerm)) {
          try {
            const codeSearch = await loadTobrosCodeSearch();
            const altTerm = codeSearch ? await codeSearch.resolve(searchTerm) : null;
            if (altTerm && this.isOpen && this.input.value.trim() === searchTerm) {
              const altResponse = await fetch(
                `${Shopify.routes.root}search/suggest?q=${encodeURIComponent(altTerm)}&resources[type]=product,page,article,collection,query&resources[limit]=8&section_id=predictive-search`
              );
              if (altResponse.ok) text = await altResponse.text();
            }
          } catch (e) {}
        }

        const resultsMarkup = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector(
            '#shopify-section-predictive-search'
          ).innerHTML;

        this.resultsContainer.innerHTML = resultsMarkup;
        this.open();

        // new added product cards - quick cart triggers - set event listeners
        document.querySelector('quick-cart-drawer')?.initTriggers();

      } catch (error) {
        this.errorMessageText.textContent = error.message;
        this.errorMessageContainer.classList.remove('hidden');
      }
    }

    open() {
      this.classList.add('is-open');
      this.resultsContainer.classList.remove('hidden');
      this.errorMessageContainer.classList.add('hidden');
      this.btnSubmit.setAttribute('tabindex', '-1');
      this.btnClearText.removeAttribute('disabled');
    }

    close() {
      this.isOpen = false;
      this.classList.remove('is-open');
      this.resultsContainer.classList.add('hidden');
      this.errorMessageContainer.classList.add('hidden');
      this.input.value = '';
      this.input.focus();
      this.btnSubmit.removeAttribute('tabindex');
      this.btnClearText.setAttribute('disabled', true);
    }
  }

  customElements.define('predictive-search', PredictiveSearch);
}
